import axios from 'axios'

const RESET = 'RESET'
const SET_ANALYTES = 'SET_ANALYTES'
const SetTenantAnalyteList = 'SetTenantAnalyteList'
const SetCurrentAnalyteDetail = 'SetCurrentAnalyteDetail'
const AddTenantAnalyte = 'AddTenantAnalyte'
const DeleteTenantAnalyte = 'DeleteTenantAnalyte'
const SetTenantAnalyteAsAlias = 'SetTenantAnalyteAsAlias'
const AddTenantAnalyteAsAlias = 'AddTenantAnalyteAsAlias'
const EditTenantAnalyteAsAlias = 'EditTenantAnalyteAsAlias'
const DeleteTenantAnalyteAsAlias = 'DeleteTenantAnalyteAsAlias'
const SetPrimaryAlias = 'SetPrimaryAlias'
const AddAnalyteGuideline = 'AddAnalyteGuideline'
const DeleteAnalyteGuideline = 'DeleteAnalyteGuideline'
const EditAnalyteName = 'EditAnalyteName'

const BASE_URL_getTenantAnalyteList = 'api/Analyte/List/'
const BASE_URL_getAnalyteDetail = 'api/Analyte/Detail/'
const BASE_URL_addTenantAnalyte = 'api/Analyte/Add'
const BASE_URL_deleteTenantAnalyte = 'api/Analyte/Delete/'
const BASE_URL_editAnalyteName = 'api/Analyte/Update'
const BASE_URL_setTenantAnalyteAsAlias = 'api/Analyte/SetAsAlias'
const BASE_URL_addTenantAnalyteAsAlias = 'api/Alias/Add'
const BASE_URL_editTenantAnalyteAsAlias = 'api/Alias/Update'
const BASE_URL_deleteTenantAnalyteAsAlias = 'api/Alias/Delete/'
const BASE_URL_setAliasAsNewAnalyte = 'api/Alias/SetAsAnalyte'
const BASE_URL_addAnalyteGuideline = 'api/GuidelineConfiguration/Add'
const BASE_URL_deleteAnalyteGuideline = 'api/GuidelineConfiguration/Delete'
const BASE_URL_analyteChecking = 'api/Analyte/DataCheck/'

function initialState() {
  return {
    analyteList: [],
    tenantAnalyteList: [],
    currentAnalyteDetail: {},
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getTenantAnalyteList({ commit }, options) {
      let url = BASE_URL_getTenantAnalyteList + options
      axios.get(url)
        .then(res => {
          commit(SetTenantAnalyteList, res.data)
        })
        .catch(() => {
          console.error('Could not get TenantAnalytes data from ' + url)
          throw 'Could not get TenantAnalytes data.'
        })
    },

    async getAnalyteDetail({ commit }, options) {
      let url = BASE_URL_getAnalyteDetail + options.data
      axios.get(url)
        .then(res => {
          commit(SetCurrentAnalyteDetail, res.data)
        })
        .catch(() => {
          console.error('Could not get Analyte data from ' + url)
          throw 'Could not get Analyte data.'
        })
    },

    async addTenantAnalyte({ commit }, options) {
      try {
        let res = await axios.post(BASE_URL_addTenantAnalyte, options.data)
        options.data.Id = res.data.Id
        commit(AddTenantAnalyte, options.data)
        options.successCb(res)
      } catch (error) {
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },

    async deleteTenantAnalyte({ commit }, options) {
      try {
        let url = BASE_URL_deleteTenantAnalyte + options.data
        await axios.delete(url)
        commit(DeleteTenantAnalyte, options.data)
        options.successCb()
      } catch (error) {
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },

    async editAnalyteName({ commit }, options) {
      try {
        await axios.put(BASE_URL_editAnalyteName, options.data)
        commit(EditAnalyteName, options.data)
        options.successCb()
      } catch (error) {
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },

    async setTenantAnalyteAsAlias({ commit }, options) {
      try {
        let postData = {}
        if (options.data.newAlias == null) {
          postData = {
            sourceAnalyteId: options.data.sourceAnalyte.Id,
            targetAnalyteId: options.data.targetAnalyte.Id,
          }
        } else {
          postData = {
            sourceAnalyteId: options.data.sourceAnalyte.Id,
            targetAnalyteId: options.data.targetAnalyte.Id,
            newAlias: options.data.newAlias,
          }
        }
        let res = await axios.post(BASE_URL_setTenantAnalyteAsAlias, postData)
        let newoptions = {
          sourceAnalyteId: options.data.sourceAnalyte.Id,
          targetAnalyteId: options.data.targetAnalyte.Id,
          newAlias: res.data,
        }
        commit(SetTenantAnalyteAsAlias, newoptions)
        options.successCb()
      } catch (error) {
        options.failedCb(error)
      }
    },

    async addTenantAnalyteAsAlias({ commit }, options) {
      try {
        let postData = {
          Id: null,
          AliasName: options.data.AliasName,
          Method: options.data.Method,
          AnalyteId: options.data.AnalyteId,
          TenantId: options.data.TenantId,
        }
        let res = await axios.post(BASE_URL_addTenantAnalyteAsAlias, postData)
        options.data.Id = res.data.Id
        commit(AddTenantAnalyteAsAlias, options.data)
        options.successCb()
      } catch (error) {
        console.error(error.response.data.ExceptionMessage)
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },

    async editTenantAnalyteAsAlias({ commit }, options) {
      try {
        let postData = {
          Id: options.data.Id,
          AliasName: options.data.AliasName,
          Method: options.data.Method,
          AnalyteId: options.data.AnalyteId,
          TenantId: options.data.TenantId,
        }
        await axios.put(BASE_URL_editTenantAnalyteAsAlias, postData)
        commit(EditTenantAnalyteAsAlias, options.data)
        options.successCb()
      } catch (error) {
        console.error(error)
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },

    async deleteTenantAnalyteAsAlias({ commit }, options) {
      try {
        let url = BASE_URL_deleteTenantAnalyteAsAlias + options.data.Id
        await axios.delete(url)
        commit(DeleteTenantAnalyteAsAlias, options.data)
        options.successCb()
      } catch (error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },

    SetPrimaryAlias({ commit }, options) {
      commit(SetPrimaryAlias, options)
    },

    async setAliasAsNewAnalyte({ commit }, options) {
      try {
        let postData = {
          Id: options.data.Id,
          AnalyteId: options.data.AnalyteId,
          AliasName: options.data.AliasName,
          Method: options.data.Method,
          TenantId: options.data.TenantId,
        }
        let res = await axios.post(BASE_URL_setAliasAsNewAnalyte, options.data)
        let newAlias = {
          ...postData,
          AnalyteId: res.data.Id,
        }
        let newAnalyte = {
          ...res.data,
          Aliases: [newAlias],
        }
        commit(AddTenantAnalyte, newAnalyte)
        commit(DeleteTenantAnalyteAsAlias, postData)
        options.successCb()
      } catch (error) {
        console.error(error)
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },

    async addAnalyteGuideline({ commit }, options) {
      try {
        let res = await axios.post(BASE_URL_addAnalyteGuideline, options.data)
        commit(AddAnalyteGuideline, res.data)
        options.successCb()
      } catch (error) {
        options.failedCb(error)
      }
    },

    async deleteAnalyteGuideline({ commit, state }, options) {
      try {
        await axios.delete(BASE_URL_deleteAnalyteGuideline, {
          data: options.data,
        })

        if (state.currentAnalyteDetail.Id == options.data.AnalyteId) {
          commit(DeleteAnalyteGuideline, options.data.StandardId)
        }
        
        options.successCb()
      } catch (error) {
        options.failedCb(error)
        console.error(error)
      }
    },
    async analyteChecking(_, options) {
      try {
        let url = BASE_URL_analyteChecking + options.data.TenantId
        let res = await axios.get(url)
        return options.success(res.data)
      } catch (error) {
        return options.fail(error)
      }
    },
  },

  mutations: {
    [SET_ANALYTES]: (s, payload) => s.analyteList = payload,

    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },

    [SetTenantAnalyteList]: (s, data) => s.tenantAnalyteList = data,
    [SetCurrentAnalyteDetail]: (s, data) => s.currentAnalyteDetail = data,

    [AddTenantAnalyte](state, data) {
      let dc = JSON.parse(JSON.stringify(state.tenantAnalyteList))
      dc.push(data)
      state.tenantAnalyteList = dc
    },

    [DeleteTenantAnalyte](state, data) {
      let dc = JSON.parse(JSON.stringify(state.tenantAnalyteList))
      let deleteId = dc.find(x => x.Id == data)
      let i = dc.indexOf(deleteId)
      dc.splice(i, 1)
      state.tenantAnalyteList = dc
    },

    [SetTenantAnalyteAsAlias](state, data) {
      let dc = JSON.parse(JSON.stringify(state.tenantAnalyteList))
      const index = dc.findIndex(x => x.Id === data.sourceAnalyteId)
      dc.splice(index, 1)
      const targetAnalyte = dc.find(x => x.Id === data.targetAnalyteId)
      targetAnalyte.Aliases = data.newAlias
      let currentAnalyteDc = JSON.parse(JSON.stringify(state.currentAnalyteDetail))
      if (data.targetAnalyteId == currentAnalyteDc.Id) {
        currentAnalyteDc.Aliases = data.newAlias
      }
      state.tenantAnalyteList = dc
      state.currentAnalyteDetail = currentAnalyteDc
    },

    [AddTenantAnalyteAsAlias](state, data) {
      state.currentAnalyteDetail.Aliases.push(data)
    },

    [EditTenantAnalyteAsAlias](state, data) {
      let dc = JSON.parse(JSON.stringify(state.currentAnalyteDetail))
      dc.Aliases.forEach(a => {
        if (a.Id == data.Id) {
          a.AliasName = data.AliasName
          a.Method = data.Method
        }
      })
      state.currentAnalyteDetail = dc
    },

    [DeleteTenantAnalyteAsAlias](state, data) {
      var dc = JSON.parse(JSON.stringify(state.currentAnalyteDetail.Aliases))
      let deldata = dc.find(e => e.Id == data.Id)
      dc.splice(dc.indexOf(deldata), 1)
      state.currentAnalyteDetail.Aliases = dc
    },

    [SetPrimaryAlias](state, data) {
      let dc = JSON.parse(JSON.stringify(state.currentAnalyteDetail))
      dc.Aliases.forEach(element => {
        element.IsPrimary = false
        if (element.Id == data.Id) {
          element.IsPrimary = true
          dc.AnalyteName = data.AliasName
        }
      })
      state.currentAnalyteDetail = dc
    },

    [AddAnalyteGuideline](state, data) {
      if (state.currentAnalyteDetail.Id == data.AnalyteId) {
        state.currentAnalyteDetail.AnalyteStandardMaps.push(data)
      }
    },

    [DeleteAnalyteGuideline](state, data) {
      let dc = JSON.parse(JSON.stringify(state.currentAnalyteDetail))
      let matched = dc.AnalyteStandardMaps.find(x => x.StandardId == data)
      let i = dc.AnalyteStandardMaps.indexOf(matched)
      dc.AnalyteStandardMaps.splice(i, 1)
      state.currentAnalyteDetail = dc
    },

    [EditAnalyteName](state, data) {
      let dc = JSON.parse(JSON.stringify(state.tenantAnalyteList))
      dc.forEach(e => {
        if (e.Id == data.Id) {
          e.AnalyteName = data.AnalyteName
          e.ApplicableUnitGroupId = data.ApplicableUnitGroupId
          e.DefaultUnitId = data.DefaultUnitId
        }
      })
      state.tenantAnalyteList = dc
      state.currentAnalyteDetail.AnalyteName = data.AnalyteName
      state.currentAnalyteDetail.DisplayName = data.DisplayName
      state.currentAnalyteDetail.ApplicableUnitGroupId = data.ApplicableUnitGroupId
      state.currentAnalyteDetail.DefaultUnitId = data.DefaultUnitId
    },
  },

  getters: {
    analyteList: s => s.analyteList,
    tenantAnalyteList: s => s.tenantAnalyteList,
    currentAnalyteDetail: s => s.currentAnalyteDetail,
  },
}